import { ProfessionIcon } from './profession-icon';

export const IconVideographer = () => (
  <ProfessionIcon bg="#E3F2FD">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <rect
        x="2"
        y="6"
        width="13"
        height="12"
        rx="2"
        stroke="#2196F3"
        strokeWidth="1.8"
      />
      <path
        d="M15 10l5-3v10l-5-3"
        stroke="#2196F3"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </ProfessionIcon>
);
